module.exports = __webpack_public_path__ + "static/media/Darchviz 13.cda156d2.jpg";